/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const es_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const de_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const nl_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const fr_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const it_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const pt_br2_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const pt_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const ja_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

const zh_hw_range = /** @type {(inputs: { min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}–${i?.max} ${i?.unit}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ min: NonNullable<unknown>, max: NonNullable<unknown>, unit: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_range = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_range(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_range", locale)
	if (locale === "en") return en_hw_range(inputs)
	if (locale === "es") return es_hw_range(inputs)
	if (locale === "de") return de_hw_range(inputs)
	if (locale === "nl") return nl_hw_range(inputs)
	if (locale === "fr") return fr_hw_range(inputs)
	if (locale === "it") return it_hw_range(inputs)
	if (locale === "pt-BR") return pt_br2_hw_range(inputs)
	if (locale === "pt") return pt_hw_range(inputs)
	if (locale === "ja") return ja_hw_range(inputs)
	return zh_hw_range(inputs)
};